// Model.js
// -----------------------
// @module Case
define("SuiteDB.SDBFooterLinks.SDBFooterLinks.SS2Model", [
  "Backbone",
  "Utils",
], function (Backbone, Utils) {
  "use strict";

  // @class Case.Fields.Model @extends Backbone.Model
  return Backbone.Model.extend({
    //@property {String} urlRoot
    urlRoot: Utils.getAbsoluteUrl(
      getExtensionAssetsPath(
        "Modules/SDBFooterLinks/SuiteScript2/SDBFooterLinks.Service.ss"
      ),
      true
    ),
  });
});
